var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlanning(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.5-.5h36c24.471 7.877 35.805 24.877 34 51 31.335-.167 62.668 0 94 .5 26.028 4.77 42.528 19.936 49.5 45.5a16612.01 16612.01 0 011 363c-5.004 27.835-21.171 45.168-48.5 52h-295c-26-6.667-42.333-23-49-49v-363c6.603-26.435 23.27-42.601 50-48.5 31.665-.5 63.332-.667 95-.5-2.204-25.756 8.796-42.756 33-51z",
    opacity: 0.986
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb454",
    d: "M181.5 16.5c9.672-.166 19.339 0 29 .5 9.465 2.798 15.632 8.965 18.5 18.5l1 50c.504 3.52 2.337 6.02 5.5 7.5 12.854-.229 25.187 2.105 37 7 7.985 7.409 10.985 16.576 9 27.5h-171c-3.177-17.62 3.823-28.454 21-32.5a1354.47 1354.47 0 0026-3l3.5-3.5 1-52c3.351-9.85 9.851-16.517 19.5-20z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#050301",
    d: "M188.5 25.5c18.168-1.974 29.168 5.86 33 23.5-2.189 20.75-13.522 29.417-34 26-14.811-7.08-19.977-18.58-15.5-34.5 3.822-6.996 9.322-11.996 16.5-15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#030100",
    d: "M511.5 104.5v275a1616.256 1616.256 0 00-24.5 48l-1 37c-4.923 17.717-16.423 24.55-34.5 20.5-8.383-3.602-13.883-9.768-16.5-18.5l-1-38a1802.102 1802.102 0 01-25-51c-.667-90.333-.667-180.667 0-271 2.235-8.236 7.568-12.903 16-14l1-37c1.833-7.167 6.333-11.667 13.5-13.5 14-.667 28-.667 42 0 6.37 1.436 10.537 5.269 12.5 11.5l1 39c7.659 1.175 13.159 5.175 16.5 12z",
    opacity: 0.982
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#f35d3f",
    d: "M191.5 42.5c10.198-.98 14.031 3.353 11.5 13-5.306 5.479-10.306 5.145-15-1-1.407-4.857-.24-8.857 3.5-12z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd6142",
    d: "M443.5 59.5h34v34h-34v-34z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#009ea3",
    d: "M337.5 68.5h-90v8c-.977-2.787-1.31-5.787-1-9 30.505-.332 60.838.002 91 1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#00e6ef",
    d: "M247.5 76.5v-8h90c16.243 2.413 27.743 11.08 34.5 26a29.503 29.503 0 012.5 14c1.183 9.217-.317 17.883-4.5 26a719.82 719.82 0 01-45 67c-.191-2.208-.691-4.208-1.5-6h-153v17c48.168.667 96.502 1.333 145 2a602.038 602.038 0 01-26 32h-120v18h103a1467.947 1467.947 0 01-32 32.5c-23.504.168-46.837.668-70 1.5v17h49a611.9 611.9 0 01-39 32.5c-3.525.179-6.859.679-10 1.5a144.255 144.255 0 00-2 7.5 893.06 893.06 0 01-67 43.5h-34v17c-3.943 2.978-8.277 5.478-13 7.5A1803.303 1803.303 0 0018 441.5c-.5-113-.667-226-.5-339 3.902-17.07 14.235-28.237 31-33.5a1594.895 1594.895 0 0196-1.5v9c-40.945 1.46-57.778 22.46-50.5 63a14.503 14.503 0 004.5 4.5c64.667.667 129.333.667 194 0a11.532 11.532 0 004.5-3.5c8.014-40.471-8.486-61.804-49.5-64z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe7855",
    d: "M426.5 110.5h68v17h-68v-17z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#00d5dd",
    d: "M17.5 102.5c-.167 113 0 226 .5 339A1803.303 1803.303 0 0154.5 425c4.723-2.022 9.057-4.522 13-7.5h68v-17h-34a893.06 893.06 0 0067-43.5c.623-2.607 1.29-5.107 2-7.5 3.141-.821 6.475-1.321 10-1.5a611.9 611.9 0 0039-32.5h104v-17h-153a2434.836 2434.836 0 0170-1.5 1467.947 1467.947 0 0032-32.5c17.175.33 34.175-.003 51-1v-16c-11.154-.995-22.488-1.328-34-1a602.038 602.038 0 0026-32c-48.498-.667-96.832-1.333-145-2h153v-17c.809 1.792 1.309 3.792 1.5 6a719.82 719.82 0 0045-67c4.183-8.117 5.683-16.783 4.5-26a19958.242 19958.242 0 01.5 346c-2.95 22.282-15.45 35.449-37.5 39.5-95.333.667-190.667.667-286 0-20.425-5.422-31.925-18.589-34.5-39.5a20660.64 20660.64 0 01.5-352z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fda632",
    d: "M426.5 144.5h68v17h-68v-17z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#fd7855",
    d: "M426.5 178.5h8c-.167 24.002 0 48.002.5 72 4.142 11.492 12.309 15.826 24.5 13a81.304 81.304 0 0017-1.5c4.317-2.315 7.15-5.815 8.5-10.5.5-24.331.667-48.664.5-73h9v188h-68v-188z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#b07d3a",
    d: "M468.5 179.5h-16v67h16c-5.475.989-11.142 1.322-17 1v-69c5.858-.322 11.525.011 17 1z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#feb654",
    d: "M468.5 179.5v67h-16v-67h16z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#004043",
    d: "M135.5 195.5v1h-67v16h-1v-17h68z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M135.5 196.5v16h-67v-16h67z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#010505",
    d: "M323.5 195.5v17h-153v-17h153z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#009096",
    d: "M135.5 195.5c.99 5.81 1.323 11.81 1 18-23.173.331-46.173-.002-69-1h68v-17z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M323.5 247.5v16h-153v-16h153z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#006a6e",
    d: "M67.5 246.5h69v18h-69v-18z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 247.5h67v16h-67v-16z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#006b6f",
    d: "M289.5 246.5c11.512-.328 22.846.005 34 1h-153v16h153a650.602 650.602 0 01-51 1h-103v-18h120z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#009096",
    d: "M67.5 298.5a1190.256 1190.256 0 0169-1c.323 6.19-.01 12.19-1 18v-17h-68z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5 298.5h67v16h-67v-16z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#010505",
    d: "M170.5 298.5h153v17h-153v-17z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#004043",
    d: "M67.5 298.5h1v16h67v1h-68v-17z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#000202",
    d: "M67.5 349.5h68v17h-68v-17z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 349.5h153v17h-153v-17z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fe6142",
    d: "M431.5 384.5c18.838-1.328 37.838-1.328 57 0l-16 32c-8.225 1.315-16.392 1.315-24.5 0a718.382 718.382 0 00-16.5-32z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#000202",
    d: "M101.5 400.5h34v17h-68v-17h34z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M170.5 400.5h153v17h-153v-17z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#85848c",
    d: "M451.5 434.5h17c.166 9.672 0 19.339-.5 29-2.541 4.569-6.375 6.069-11.5 4.5-2.31-1.637-3.81-3.804-4.5-6.5-.5-8.994-.666-17.994-.5-27z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanning);
export default __webpack_public_path__ + "static/media/planning.67d6364d.svg";
export { ForwardRef as ReactComponent };